import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const DevicesPage = lazy(() => import('@cobliteam/devices'));

const routes = [
  {
    path: Location.DEVICES,
    team: 'squad-account-experience',
    component: DevicesPage,
    exact: true,
  },
];

export default routes;
